<div class="card card-block page-card">
    <div class="card card-block mb-3">
        <!-- <div class="checkbox">
            <label class="mb-0">
                <input type="checkbox" [(ngModel)]="showOnlyWithResponse" (change)="changeFilter()">
                Show only with response
            </label>
        </div> -->
        <!-- <form class="form-inline">
            
          </form> -->
        <ng-select 
            [items]="responseFilterData" 
            [closeOnSelect]="true" 
            bindLabel="label"
            placeholder="Filter by response"
            [(ngModel)]="selectedResponseFilter"
            (change)="changeResponseFilter()"
            name="groupsFilter"
            class="w-25"
        ></ng-select>
    </div>
    <ng-table [config]="config" [columns]="columns" [data]="componentsFilteredData"></ng-table>
    <hr />
    <form class="form-inline">
        <div class="mr-auto"></div>
        <button type="button" class="btn btn-light" (click)="onClose()">Close</button>
    </form>
</div>